module.exports = __webpack_public_path__ + "static/media/textlabel_Step 4.9c9fa908.png";